/**
 * Shared types for ProductImagesSubTab components and hooks.
 */

import type { ProductAsset } from '@/types/products';
import type { RoleOption } from './RoleSelector';

/** Rollen fuer KI-Referenzbilder */
export const AI_ROLES: RoleOption[] = [
  { value: 'PACKSHOT', label: 'Packshot', icon: '📦', color: 'bg-orange-600/90' },
  { value: 'LIFESTYLE', label: 'Lifestyle', icon: '🌿', color: 'bg-green-600/90' },
  { value: 'DETAIL', label: 'Detail', icon: '📸', color: 'bg-primary-600/90' },
  { value: 'BRAND', label: 'Brand', icon: '🏷️', color: 'bg-primary-600/90' },
];

export type ImageSize = 'S' | 'M' | 'L';

/** Image size configuration (minmax values for responsive grid) */
export const IMAGE_SIZES = {
  S: 120, // Compact: Quick sorting
  M: 180, // Default: Balanced view
  L: 285, // Detail: Quality check
} as const;

/** Cross-Container DnD: Custom data type for drag items */
export interface DragItemData {
  asset: ProductAsset;
  channelKey: string;
  channelId: string | null;
  fromLibrary?: boolean;
}

/** Channel order state type */
export interface ChannelOrderState {
  channelId: string | null; // null = global
  originalOrder: string[];
  currentOrder: string[];
}

/** Pending copies: Cross-container drops waiting to be saved */
export interface PendingCopy {
  sourceAssetId: string;
  sourceChannelId: string | null;
  targetChannelId: string;
  targetChannelKey: string;
  asset: ProductAsset;
  insertAtIndex?: number;
}

/** Pending uploads: Uploaded assets waiting to be linked */
export interface PendingUpload {
  assetId: string;
  channelId: string;
  channelKey: string;
  width: number;
  height: number;
  insertAtIndex?: number;
}

/** Callback type for upload results (avoids collision with API type) */
export interface PendingUploadResultForCallback {
  assetId: string;
  contentHash: string;
  width: number;
  height: number;
}
